export const environment = {
    google: {
        GOOGLE_CLIENT_ID: "9643973506-ov2ji67gq7k6tla4q30s9glc9f5g3a2b.apps.googleusercontent.com",
        GOOGLE_CLIENT_SECRET: "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",
        GOOGLE_API_KEY: "AIzaSyDYAyYyO0KB0EhstdOUb6QRBSk_AS0Da4Y",
        RECAPTCHA_KEY:"6LcDm2kpAAAAAH4rSLWeH8nX3qB0EgVtY3t_lN4B",
        RECAPTCHA_SECRET: "6LcDm2kpAAAAAAWRizLrE8n49pdDzvpWTiEDvGm3",
        ANALYTICS: "G-5FNHTEEE77"
    },
    facebook: {
        FACEBOOK_APP_ID:"2357023697819380",
        FACEBOOK_APP_SECRET: "f7b42c38805c50eb19836a544cb8af9b",
    },
    cloudinary: {
        CLOUDINARY_API_KEY:"346132415757177",
        CLOUDINARY_API_SECRET:"e8wtcNaIA6inRlIQRyZ2ehAdl00",
        CLOUDINARY_API_CLOUD: "dapc3dsxv",
    },
    paypal: {
        PAYPAL_SANDBOX:true,
        PAYPAL_SANDBOX_CLIENT_ID:"AZr-Xodo9qz8Q-0Njgl8w_oKSWtKJBdZNo_wMhQmEjN3WvXWeBR7mk36zmCZImmz03JWjbMmJoegZqmg",
        PAYPAL_SANDBOX_CLIENT_SECRET:"EE2eKpvxAvI_poFZeVriyWGWdQT1Fr1S7Yp3ZXvMsd-fTKmyul5BU2vcvLyHyqSQk_71N2XbEEJozWNG",
        PAYPAL_CLIENT_ID:"AcZBxEtVxq308mof8Cb7uFmiM8CmzmlRX3e3TF1OhAx8RzRfDFxF-dp0OQYEMPbgNf7-qqw5pj96EyNq",
        PAYPAL_CLIENT_SECRET: "EAmerrGHwddeZoDkQxzDWMqzrWIPsWCbf2ChMzPvKksda98I5ubuWeJbLkWwwbWmAD73OI7JGmhGfuhF",
    },
    microsoft: {
        AZURE_EMAIL_ENDPOINT:"endpoint=https://lrpticketscommunications.uk.communication.azure.com/;accessKey=LL1/bY4p91D1dzmMoMersP5lcxVECeW47ox02gEhUL5I+4+nvJ4NxqsnzIaaVjZscVwnZBjzWV0GkC/9wKziuw==",
        AZURE_EMAIL_ADDRESS: "donotreply@lrptickets.co.uk",
        AD_CLIENT_SECRET: "dYQ8Q~P3P8Q~hbwbdvBxUqXM3wbWiBNW2qUntq4QmGucBQ",
        AD_CLIENT_ID: "31ea5532-e0bd-4ac5-b9c1-b14000212306",
        AD_REDIRECT: 'https://preview.lrptickets.co.uk',
        APP_INSIGHTS: {
            CONNECTION_STRING: "InstrumentationKey=d17407b8-da78-4ff1-b430-27094a225cdc;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=6f17c3ea-6d36-4bde-b9f0-807163677a65",
            INSTRUMENTATION_KEY: "d17407b8-da78-4ff1-b430-27094a225cdc"
        },
        CLARITY: "rrl9u3utiy"
    },
    cookie: {
      DOMAIN: 'preview.lrptickets.co.uk'  
    },
    production: false,
    preview: true,
    EMAIL_TYPE: "AZURE",
    LTAPI_KEY: "TFRDSF9BUFA6MChPZiZ3Q1EkZ2pLMjdIQCFNKEg1QDde",
    API: 'https://api.lrptickets.co.uk'
  };